export type Step = {
    name: string;
    order: number;
};

export enum ANIMATION_DIRECTION {
    FROM_LEFT_TO_RIGHT = "from-left-to-right",
    FROM_RIGHT_TO_LEFT = "from-right-to-left",
    NO_ANIMATION = "no-animation",
}

export type StepAnimation = {
    inAnimation: ANIMATION_DIRECTION;
    outAnimation: ANIMATION_DIRECTION;
};
